<edge-shell [config]="shellConfig">
    <router-outlet/>
</edge-shell>
